import type { WorkflowPayload } from '../types/database.types'
import { SchemaValidationError, assertKnownKeys, assertObject } from './strict'

const VERIFIED_WORKFLOW_COLUMNS = [
  'current_step_id',
  'next_action_due_at',
  'state',
] as const

export function buildWorkflowPayload(input: unknown): WorkflowPayload {
  const source = assertObject(input, 'Workflow payload')
  assertKnownKeys(source, VERIFIED_WORKFLOW_COLUMNS, 'Workflow payload')

  if (Object.keys(source).length === 0) {
    throw new SchemaValidationError('Workflow payload cannot be empty.')
  }

  return source as WorkflowPayload
}
